import { initializeApp, getApps } from "firebase/app";
import { config, firebaseConfig } from "../config";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore/lite";
import { getMessaging, isSupported } from "firebase/messaging";

export const firebaseApp =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export const firebaseAuth = getAuth(firebaseApp);
export const firebaseDb = getFirestore(firebaseApp, config.DB_NAME);

export const firebaseMessaging = isSupported().then((supported) =>
  supported ? getMessaging(firebaseApp) : null,
);
